export default __webpack_public_path__ + "static/media/logo-invision.9914cf42.svg";